import React from 'react';
import { MailIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../data/contact';
export function SiteFooter() {
  return <footer className="border-t border-night-600 bg-night-950 py-12 sm:py-14" data-id="element-292" data-mp="3r8riyvrk2k10">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-293" data-mp="3mghkgrcdkbn4">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-294" data-mp="3hig2k9qoqid8">
          <div className="max-w-md" data-id="element-295" data-mp="3hglqzm1b02lt">
            <p className="font-display text-2xl leading-tight text-cream" data-id="element-296" data-mp="3dh4lislvn5gn">
              Arsenał Nauczyciela <span className="text-amber" data-id="element-297" data-mp="38hi8ok9ynr8d">Jazzu&trade;</span>
            </p>
            <p className="mt-2 text-sm text-cream-muted" data-id="element-298" data-mp="33ioqiejqbc1v">
              Kompletny system dla profesjonalnych pedagogów jazzu.
            </p>
            <p className="mt-5 font-serif text-base italic leading-snug text-cream-soft" data-id="element-299" data-mp="2ykvolxpgl47e">
              Bo uczenie jazzu nie powinno kosztować Cię każdego wieczoru w tygodniu.
            </p>
          </div>
          <nav aria-label="Stopka" className="flex flex-col gap-3" data-id="element-300" data-mp="wtii547ueo98">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="flex items-center gap-3 text-sm text-cream-soft transition-colors duration-150 ease-out hover:text-amber" data-id="element-301" data-mp="15qbz88pnn5db">
              <MailIcon className="h-4 w-4 text-amber" aria-hidden="true" data-id="element-302" data-mp="vth1hs17h903" />
              {SUPPORT_EMAIL}
            </a>
          </nav>
        </div>
        <p className="mt-10 border-t border-night-600 pt-6 text-[10px] uppercase tracking-label text-cream-muted sm:text-[11px]" data-id="element-303" data-mp="10tv58xvrxwsb">
          &copy; Arsenał Nauczyciela Jazzu&trade; 2026 &mdash; Wszelkie prawa zastrzeżone.
        </p>
      </div>
    </footer>;
}